import { Fragment } from 'react';
import { noop } from 'shell/utils/noop';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { NotesTextVisualizeCrumbs } from 'civil-status/constants/notes-text-breadcrumb';
import FormNotesText, { NotesTextForm } from 'civil-status/components/notes-text/form';
import { useNavigate, useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { HttpResponse } from 'shell/models/http-response';
import { NotesText } from 'shell/models/notes-text';
import { transformResponseNoteText } from 'civil-status/utils/transformer-note-text';

const NotesTextDetailPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const [noteText] = useHttpFetch<HttpResponse<NotesText>, NotesTextForm>(
    `${__CIVIL_STATUS_API_URL__}/testo-annotazione/${params.id}`,
    {
      onBootstrap: true,
      transformer: transformResponseNoteText,
    }
  );

  const isLoading = noteText.isLoading || noteText.pristine || noteText.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs items={NotesTextVisualizeCrumbs} />
      {!isLoading ? (
        <FormNotesText
          title={'Dettaglio Annotazione'}
          onOk={noop}
          onCancel={() => {
            navigate('/stato-civile/annotazioni');
          }}
          disabled
          initialValues={noteText.data as NotesTextForm}
        ></FormNotesText>
      ) : undefined}
    </Fragment>
  );
};

NotesTextDetailPage.displayName = 'Notes Text Detail page component';

export default NotesTextDetailPage;
